<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>
            {{
              positionName == "FRANCHISEE ADMIN"
                ? "Submit Document"
                : "Review Kyc Document"
            }}</span
          >
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-text-field
                v-model="form.document_type_name"
                outlined
                hide-details="auto"
                readonly
                label="Document Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-text-field
                v-model="form.document_number"
                outlined
                hide-details="auto"
                label="Document Number *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.document_number"
              ></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <input
                type="file"
                id="document_path"
                name="document_path"
                ref="document_path"
                @change="onFileChange"
              />
            </v-col>
            <v-col v-if="document_path_preview" lg="4" md="4" sm="4" cols="12">
              <template>
                <div id="preview" class="mt-5">
                  <label for="">Image Preview</label>
                  <br />
                  <a
                    @click.prevent="
                      handleImageClick(document_path_preview, 'image_path.jpg')
                    "
                  >
                    <v-img
                      width="300px !important"
                      height="300px !important"
                      :src="document_path_preview"
                    />
                  </a>
                </div>
                <v-btn
                  x-small
                  class="reset_image my-1"
                  color="red"
                  dark
                  @click="
                    ($refs.document_path.value = null),
                      (document_path_preview = null)
                  "
                  >Remove</v-btn
                >
              </template>
            </v-col>
            <v-col
              lg="4"
              md="4"
              sm="4"
              cols="12"
              v-if="visible_to(['ADMIN', 'SUPER ADMIN', 'MASTER FRANCHISEE'])"
            >
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col
              lg="4"
              md="4"
              sm="4"
              cols="12"
              v-if="visible_to(['ADMIN', 'SUPER ADMIN', 'MASTER FRANCHISEE'])"
            >
              <v-autocomplete
                v-model="form.status"
                outlined
                hide-details="auto"
                :items="statusItems"
                label="Status"
                prepend-inner-icon="mdi-checkbox-marked-circle-outline"
              ></v-autocomplete>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12" v-if="form.status == 2">
              <v-text-field
                v-model="form.remark"
                outlined
                hide-details="auto"
                :readonly="positionName == 'FRANCHISEE ADMIN' ? true : false"
                label="Remark"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Bank details of the franchisee: Admin can edit, saved with the review -->
          <bank-details-fields v-if="form.franchisee" :form="form.franchisee" />

          <v-divider class="mt-5 mb-5"> </v-divider>
          <v-btn v-can:edit="['franchisees', 'kyc_documents']"
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            rounded
            @click="save"
          >
            {{
              positionName == "FRANCHISEE ADMIN"
                ? "Submit Document"
                : "Update Review"
            }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "FranchiseeKYCDocumentEditPage",
  data() {
    return {
      form: {},
      isLoading: false,
      isFetching: false,
      imageErrors: "",
      imageLoader: "",
      document_path_preview: "",
      warningImageLoader: "",
      image_path_preview: "",
      statusItems: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
        { id: "REJECTED", text: "REJECTED", value: 2 },
      ],
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    // The review payload plus the franchisee's bank details (the API only applies them for Admin)
    withBank() {
      const o = this.form.franchisee;
      if (!o) return this.form;
      return {
        ...this.form,
        account_number: o.account_number || "",
        ifsc_code: o.ifsc_code || "",
        bank_name: o.bank_name || "",
      };
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.franchiseeKycDocumentId;
      axios
        .get(`/franchisee_kyc_documents/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.form.document_type_name = this.form.document_type.code;
          console.log(this.form);
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.is_active = this.form.status == 2 ? 0 : 1;
        await axios
          .patch(
            `/franchisee_kyc_documents/${this.$route.params.franchiseeKycDocumentId}`,
            this.withBank()
          )
          .then(async (response) => {
            console.log(response);
            let response_payload = response.data;
            if (response.status == 208) {
              let Dialog_title = response_payload.title;
              const { "sub-title": Dialog_subtitle } = response_payload;
              this.isShowPopUP(Dialog_title, Dialog_subtitle);
            } else {
              await this.handleFileUpload();
              this.$router.back();
            }
          });
        this.isLoading = false;
      } catch (error) {
        // NOW this works, because we aren't mixing .catch()
        console.log("Axios error caught, status:", error);
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      console.log("Upload");
      let formData = new FormData();
      this.imagepath_attachment = this.$refs.document_path.files[0];
      formData.append("id", this.form.id);
      formData.append("document_path", this.imagepath_attachment);
      await axios
        .post(
          "franchisee_kyc_documents/upload_franchisee_kyc_document",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
      this.isUploading = false;
    },
    handleImageClick(imageUrl, filename) {
      window.open(imageUrl, "_blank");
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = filename;
      link.click();
    },
    onFileChange() {
      this.warningImageLoader = false;
      if (this.$refs.document_path?.files[0]) {
        // Pan Image
        let file = this.$refs.document_path?.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let img = new Image();
          img.onload = () => {
            this.imageLoader = false;
            this.document_path_preview = URL.createObjectURL(file);
            this.imageErrors = "";
            console.log(this.document_path_preview);
          };
          img.src = evt.target.result;
        };
        reader.onerror = (evt) => {
          console.error(evt);
        };
      }
    },
  },
};
</script>
